import React, { useState, useEffect, useMemo } from 'react'
import { Card, Col, Form, Row } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import toast from 'react-hot-toast'
import axios from 'axios'
import Cookies from 'js-cookie'
import { FaSyncAlt } from 'react-icons/fa'
import {
  BsFunnelFill,
  BsSearch,
  BsChevronLeft,
  BsChevronRight,
  BsCalendar3,
} from 'react-icons/bs'
import { LuGraduationCap } from 'react-icons/lu'
import { useNavigate, useParams } from 'react-router-dom'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import { useInstitute } from './commonComponents/InstituteContext'

const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

const toDateKey = (dateValue) => {
  if (!dateValue) return null

  if (dateValue instanceof Date && !Number.isNaN(dateValue.getTime())) {
    const y = dateValue.getFullYear()
    const m = String(dateValue.getMonth() + 1).padStart(2, '0')
    const day = String(dateValue.getDate()).padStart(2, '0')
    return `${y}-${m}-${day}`
  }

  const raw = String(dateValue).trim()
  if (/^\d{4}-\d{2}-\d{2}/.test(raw)) {
    return raw.slice(0, 10)
  }

  // DD-MM-YYYY or DD/MM/YYYY (common API / locale formats)
  const dmy = raw.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/)
  if (dmy) {
    const day = dmy[1].padStart(2, '0')
    const month = dmy[2].padStart(2, '0')
    return `${dmy[3]}-${month}-${day}`
  }

  const d = new Date(raw)
  if (Number.isNaN(d.getTime())) return null
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

const normalizeStatus = (status) => {
  const s = String(status || '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '_')

  if (
    s === 'l' ||
    s === 'on_leave' ||
    s === 'onleave' ||
    s === 'on-leave' ||
    s === 'student_leave'
  ) {
    return 'leave'
  }

  return s
}

const getStatusColor = (status) => {
  const s = normalizeStatus(status)
  if (s === 'present') return '#10B981'
  if (s === 'absent') return '#EF4444'
  if (s === 'leave') return '#F59E0B'
  if (s === 'half_day') return '#3B82F6'
  if (s === 'late') return '#8B5CF6'
  if (s === 'holiday') return '#F59E0B'
  return '#6b7280'
}

const getStatusBg = (status) => {
  const s = normalizeStatus(status)
  if (s === 'present') return 'rgba(16, 185, 129, 0.18)'
  if (s === 'absent') return 'rgba(239, 68, 68, 0.18)'
  if (s === 'leave') return 'rgba(245, 158, 11, 0.22)'
  if (s === 'half_day') return 'rgba(59, 130, 246, 0.18)'
  if (s === 'late') return 'rgba(139, 92, 246, 0.18)'
  if (s === 'holiday') return 'rgba(245, 158, 11, 0.18)'
  return 'transparent'
}

const formatDisplayStatus = (status) => {
  if (!status) return 'N/A'
  return (
    String(status).charAt(0).toUpperCase() +
    String(status).slice(1).replace(/_/g, ' ')
  )
}

export default function ViewAttendance() {
  const { logout } = useAuth()
  const { isCollapsed } = useSidebar()
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const { logo } = useInstitute()
  const [openTable, setOpenTable] = useState(false)
  const [showFilterCard, setShowFilterCard] = useState(false)

  const { student_id, course_id, class_id } = useParams()
  console.log(
    'STUDENT ID:',
    student_id,
    'COURSE ID: ',
    course_id,
    'CLASS_ID:',
    class_id,
  )
  const [courses, setCourses] = useState([])
  const [classes, setClasses] = useState([])
  const [allStudents, setAllStudents] = useState([])
  const [filteredStudents, setFilteredStudents] = useState([])
  const [selectedStudent, setSelectedStudent] = useState(null)
  const [selectedData, setSelectedData] = useState([])
  const [allTeachers, setAllTeachers] = useState([])
  const [attendanceData, setAttendanceData] = useState([])
  const [selectedCourseId, setSelectedCourseId] = useState('')
  const [selectedClassId, setSelectedClassId] = useState('')
  const [admissionNo, setAdmissionNo] = useState('')
  const [fromDate, setFromDate] = useState(null)
  const [toDate, setToDate] = useState(null)
  const [calendarMonth, setCalendarMonth] = useState(() => {
    const now = new Date()
    return new Date(now.getFullYear(), now.getMonth(), 1)
  })
  const [selectedDayKey, setSelectedDayKey] = useState(null)
  const navigate = useNavigate()

  useEffect(() => {
    if (allStudents.length > 0 && student_id && course_id && class_id) {
      console.log('✅ useEffect triggered with params:')
      console.log('All Students:', allStudents)
      console.log('student_id:', student_id)
      console.log('course_id:', course_id)
      console.log('class_id:', class_id)

      const urlStudentId = Number(student_id)
      const urlClassId = Number(class_id)
      const student = allStudents.find((s) => Number(s.id) === urlStudentId)
      console.log('Found student:', student)

      if (student) {
        const resolvedClassId = urlClassId || Number(student.class_id)
        setSelectedStudent(student)
        setSelectedCourseId(student.course_id)
        setSelectedClassId(resolvedClassId)

        // Set course and load classes
        ApiEndpoints.getAllClassesByCourseId(student.course_id).then((res) => {
          console.log('Classes fetched for course:', res.data.data)
          setClasses(res.data.data || [])
        })

        // Fetch by class (same as Take Attendance), then filter client-side so
        // every status including leave is included for this student.
        ApiEndpoints.getAllAttendance({
          class_id: resolvedClassId,
        }).then((res) => {
          console.log('Attendance data fetched:', res.data.attendance)

          const attendanceList = res.data.attendance || []
          const filteredAttendance = attendanceList
            .filter((entry) => Number(entry.student_id) === urlStudentId)
            .map((entry) => ({
              ...entry,
              date: toDateKey(entry.date) || entry.date,
              status: normalizeStatus(entry.status) || entry.status,
            }))

          console.log('✅ Filtered attendance for student:', filteredAttendance)

          setAttendanceData(filteredAttendance)
          setSelectedData(filteredAttendance)
          setOpenTable(true)
        })

        // Set filtered students of that class
        const filtered = allStudents.filter(
          (s) => Number(s.course_id) === Number(student.course_id),
        )
        console.log('Filtered students by course:', filtered)
        setFilteredStudents(filtered)
      } else {
        console.warn('No matching student found for ID:', student_id)
      }
    }
  }, [allStudents, student_id, course_id, class_id])

  useEffect(() => {
    if (fromDate && toDate) {
      const fromKey = toDateKey(fromDate)
      const toKey = toDateKey(toDate)
      const filtered = attendanceData.filter((item) => {
        const itemKey = toDateKey(item.date)
        if (!itemKey || !fromKey || !toKey) return false
        return itemKey >= fromKey && itemKey <= toKey
      })
      setSelectedData(filtered)
    } else {
      setSelectedData(attendanceData)
    }
  }, [fromDate, toDate, attendanceData])

  useEffect(() => {
    ApiEndpoints.getAllCourses()
      .then((res) => setCourses(res.data.data))
      .catch(console.error)
  }, [])

  useEffect(() => {
    const institueId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')

    let token = null
    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
        console.log('TOKEN:', token)
      } catch (error) {
        console.error('Failed to parse user cookie', error)
      }
    }
    const fetchFilteredData = async () => {
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'institute-Id': Number(institueId),
        }

        const response = await axios.get(
          BASE_URL+'/student/all',
          { headers },
        )
        console.log('Response of all students:', response.data.data)
        setAllStudents(response.data.data)
      } catch (error) {
        console.error(error.response?.data?.message || 'Something wents wrong.')
      }
    }
    fetchFilteredData()
  }, [])
  const handleCourseChange = async (e) => {
    const courseId = Number(e.target.value)
    setSelectedCourseId(courseId)

    // Reset dependent data
    setClasses([])
    setFilteredStudents([])
    setSelectedStudent(null)

    if (courseId) {
      try {
        const res = await ApiEndpoints.getAllClassesByCourseId(courseId)
        const classList = res.data.data || []
        setClasses(classList)

        // Filter students for this course
        const filtered = allStudents.filter((s) => s.course_id === courseId)
        setFilteredStudents(filtered)
      } catch (error) {
        toast.error('Error fetching classes or students.')
      }
    }
  }

  const handleRefresh = async () => {
    // Reset selected student, class, and attendance data
    setSelectedStudent(null)
    setSelectedClassId('')
    setSelectedCourseId('')
    setFilteredStudents([])
    setSelectedData([])
    setOpenTable(false)
    setFromDate(null)
    setToDate(null)
    navigate('/ViewAttendance')
    // Refetch courses
    try {
      const res = await ApiEndpoints.getAllCourses()
      setCourses(res.data.data) // Set fetched courses
    } catch (error) {
      console.error('Error fetching courses:', error)
    }

    // Optionally, you can also refetch all students, classes, etc., as needed.
    try {
      const institueId = Cookies.get('institute_id')
      const userCookie = Cookies.get('user')
      let token = null
      if (userCookie) {
        try {
          const user = JSON.parse(userCookie)
          token = user.token
        } catch (error) {
          console.error('Failed to parse user cookie', error)
        }
      }

      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'institute-Id': Number(institueId),
      }

      const response = await axios.get(
        BASE_URL+'/student/all',
        { headers },
      )
      setAllStudents(response.data.data)
    } catch (error) {
      console.error(error.response?.data?.message || 'Something went wrong.')
    }
  }

  const handleDateFilterRefresh = () => {
    setFromDate(null)
    setToDate(null)
    setSelectedDayKey(null)
  }

  const handleClassChange = async (e) => {
    const classId = e.target.value
    setSelectedClassId(classId)
    setSelectedStudent(null)

    console.log('Selected Class ID:', classId)

    try {
      const payload = { class_id: parseInt(classId) }
      console.log('Fetching attendance with payload:', payload)

      const res = await ApiEndpoints.getAllAttendance(payload)
      setAttendanceData(res.data.attendance) // ✅ store full
      console.log('Attendance by Class:', res.data.attendance)
      setSelectedData(res.data.attendance)
    } catch (error) {
      console.error(
        'Error fetching attendance by class:',
        error.response?.data?.message,
      )
    }

    // Filter students by class
    const filtered = allStudents.filter(
      (student) => student.class_id === Number(classId),
    )
    setFilteredStudents(filtered)
    setOpenTable(true)
  }
  const handleStudentChange = async (e) => {
    const studentId = Number(e.target.value)
    const student = filteredStudents.find((s) => s.id === studentId)

    if (student) {
      setSelectedStudent(student)
      setSelectedCourseId(student.course_id) // sync course dropdown
      // setSelectedClassId(student.class_id)
      // Fetch classes for course if not already fetched
      if (!classes.length) {
        const res = await ApiEndpoints.getAllClassesByCourseId(
          student.course_id,
        )
        setClasses(res.data.data || [])
      }

      setOpenTable(true)

      try {
        const res = await ApiEndpoints.getAllAttendance({
          class_id: Number(student.class_id),
        })
        const filteredAttendance = (res.data.attendance || [])
          .filter((entry) => Number(entry.student_id) === Number(student.id))
          .map((entry) => ({
            ...entry,
            date: toDateKey(entry.date) || entry.date,
            status: normalizeStatus(entry.status) || entry.status,
          }))
        setAttendanceData(filteredAttendance)
        setSelectedData(filteredAttendance)
      } catch (error) {
        console.error(
          'Error fetching student attendance:',
          error.response?.data?.message,
        )
      }
    }
  }

  useEffect(() => {
    if (!attendanceData.length) return

    const latest = attendanceData.reduce((max, item) => {
      const key = toDateKey(item.date)
      if (!key) return max
      return !max || key > max ? key : max
    }, null)

    if (latest) {
      const [y, m] = latest.split('-').map(Number)
      setCalendarMonth(new Date(y, m - 1, 1))
    }
  }, [attendanceData])

  const attendanceByDate = useMemo(() => {
    const map = {}
    ;(selectedData || []).forEach((entry) => {
      const key = toDateKey(entry.date)
      if (!key) return
      map[key] = entry
    })
    return map
  }, [selectedData])

  const calendarDays = useMemo(() => {
    const year = calendarMonth.getFullYear()
    const month = calendarMonth.getMonth()
    const firstDay = new Date(year, month, 1)
    const daysInMonth = new Date(year, month + 1, 0).getDate()
    const startWeekday = firstDay.getDay()
    const cells = []

    for (let i = 0; i < startWeekday; i += 1) {
      cells.push({ type: 'empty', key: `empty-start-${i}` })
    }

    for (let day = 1; day <= daysInMonth; day += 1) {
      const key = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`
      cells.push({
        type: 'day',
        key,
        day,
        attendance: attendanceByDate[key] || null,
      })
    }

    while (cells.length % 7 !== 0) {
      cells.push({ type: 'empty', key: `empty-end-${cells.length}` })
    }

    return cells
  }, [calendarMonth, attendanceByDate])

  const monthStats = useMemo(() => {
    const year = calendarMonth.getFullYear()
    const month = calendarMonth.getMonth()
    const stats = { present: 0, absent: 0, leave: 0, half_day: 0, late: 0, other: 0, total: 0 }

    Object.values(attendanceByDate).forEach((entry) => {
      const key = toDateKey(entry.date)
      if (!key) return
      const [y, m] = key.split('-').map(Number)
      if (y !== year || m !== month + 1) return

      stats.total += 1
      const s = normalizeStatus(entry.status)
      if (s === 'present') stats.present += 1
      else if (s === 'absent') stats.absent += 1
      else if (s === 'leave') stats.leave += 1
      else if (s === 'half_day') stats.half_day += 1
      else if (s === 'late') stats.late += 1
      else stats.other += 1
    })

    return stats
  }, [attendanceByDate, calendarMonth])

  const selectedDayAttendance = selectedDayKey
    ? attendanceByDate[selectedDayKey] || null
    : null

  const todayKey = toDateKey(new Date())

  const goToPrevMonth = () => {
    setCalendarMonth(
      (prev) => new Date(prev.getFullYear(), prev.getMonth() - 1, 1),
    )
    setSelectedDayKey(null)
  }

  const goToNextMonth = () => {
    setCalendarMonth(
      (prev) => new Date(prev.getFullYear(), prev.getMonth() + 1, 1),
    )
    setSelectedDayKey(null)
  }

  const goToCurrentMonth = () => {
    const now = new Date()
    setCalendarMonth(new Date(now.getFullYear(), now.getMonth(), 1))
    setSelectedDayKey(null)
  }

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed ? `${collapsedWidth + gap}px` : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }
      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  return (
    <div
      style={{
        marginLeft,
        transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
        willChange: 'margin-left',
        WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
        position: 'relative',
        zIndex: 1,
        marginTop: '0px',
        marginRight: '0px',
        marginBottom: '0px',
        paddingLeft: isCollapsed ? '62px' : '12px',
        paddingRight: isCollapsed ? '62px' : '12px',
      }}
    >
      <div
        className="container-fluid p-0"
        style={{
          marginTop: window.innerWidth < 992 ? '55px' : '-12px',
          paddingLeft: '0px',
          paddingRight: '0px',
        }}
      >
        <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
          <div
            className="d-flex justify-content-between align-items-center"
            style={{
              background: '#F3F4F6',
              paddingLeft: '28px',
              paddingRight: '28px',
              paddingTop: '12px',
              paddingBottom: '12px',
              overflow: 'visible',
              borderBottom: '1px solid #D1D3D4',
            }}
          >
            <div className="d-flex align-items-center gap-3" style={{ flex: 1 }}>
              <div
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  overflow: 'hidden',
                  background: '#223843',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}
              >
                {!logoError ? (
                  <img
                    src={logo}
                    alt="School Logo"
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={() => setLogoError(true)}
                  />
                ) : (
                  <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                )}
              </div>

              <div>
                <h3
                  className="m-0 fw-bold text-start"
                  style={{
                    letterSpacing: '-0.02em',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    fontSize: 'clamp(18px, 2.5vw, 22px)',
                    color: '#223843',
                    lineHeight: '1.2',
                    fontFamily: 'Inter, system-ui, sans-serif',
                  }}
                >
                  Attendance
                </h3>
                <p
                  className="m-0 mt-1 text-start"
                  style={{
                    fontSize: window.innerWidth < 768 ? '11px' : '13px',
                    color: '#6b7280',
                    fontWeight: '400',
                    fontFamily: 'Inter, system-ui, sans-serif',
                  }}
                >
                  {selectedStudent
                    ? `View ${
                        selectedStudent.name.charAt(0).toUpperCase() +
                        selectedStudent.name.slice(1).toLowerCase()
                      }'s attendance.`
                    : 'View student attendance.'}
                </p>
              </div>
            </div>

            {!isMobile && <ProfileDropdown logout={logout} />}
          </div>
        </div>
      </div>

      <div
        className="container-fluid p-0 mt-4"
        style={{
          minHeight: '100vh',
          paddingLeft: isCollapsed ? '32px' : '40px',
          paddingRight: '32px',
          paddingTop: '32px',
          paddingBottom: '32px',
        }}
      >

        {openTable && (
          <>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div
                className="d-flex align-items-center"
                style={{
                  backgroundColor: '#ffffff',
                  padding: '8px 14px',
                  borderRadius: '10px',
                  gap: '10px',
                  border: '1px solid #D1D3D4',
                }}
              >
                <div
                  style={{
                    width: '34px',
                    height: '34px',
                    borderRadius: '50%',
                    backgroundColor: '#223843',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}
                >
                  <BsSearch style={{ color: '#ffffff', fontSize: '16px' }} />
                </div>
                <div className="text-start">
                  <div
                    style={{
                      fontSize: '13px',
                      fontWeight: 700,
                      color: '#111827',
                      fontFamily: 'Inter, system-ui, sans-serif',
                      lineHeight: 1.1,
                    }}
                  >
                    Calendar filters
                  </div>
                  <div
                    style={{
                      fontSize: '12px',
                      color: '#6b7280',
                      fontFamily: 'Inter, system-ui, sans-serif',
                    }}
                  >
                    Narrow the date range on the calendar
                  </div>
                </div>
              </div>

              {/* <button
                type="button"
                onClick={() => setShowFilterCard((v) => !v)}
                style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: showFilterCard ? '#223843' : '#ffffff',
                  border: '1px solid #D1D3D4',
                  color: showFilterCard ? '#ffffff' : '#223843',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  flexShrink: 0,
                }}
                title={showFilterCard ? 'Hide Filters' : 'Show Filters'}
              >
                <BsFunnelFill size={20} />
              </button> */}
            </div>

            <div
              style={{
                maxHeight: showFilterCard ? '500px' : '0',
                overflow: 'hidden',
                transition: 'max-height 0.3s ease-in-out',
                marginBottom: showFilterCard ? '16px' : '0',
              }}
            >
              {showFilterCard && (
                <Card
                  style={{
                    border: '1px solid #D1D3D4',
                    borderRadius: '12px',
                    backgroundColor: '#ffffff',
                    overflow: 'hidden',
                  }}
                >
                  <div
                    style={{
                      background: '#ffffff',
                      padding: '16px 18px',
                      borderBottom: '1px solid #F3F4F6',
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center gap-3 flex-wrap">
                      <div className="d-flex align-items-center gap-3">
                        <div
                          style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            backgroundColor: '#223843',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                          }}
                        >
                          <BsSearch style={{ color: '#ffffff', fontSize: '18px' }} />
                        </div>
                        <div className="text-start">
                          <h5
                            className="m-0 fw-semibold"
                            style={{
                              color: '#111827',
                              fontSize: '16px',
                              fontFamily: 'Inter, system-ui, sans-serif',
                            }}
                          >
                            Search & Filter Attendance
                          </h5>
                          <p className="m-0 mt-1" style={{ fontSize: '13px', color: '#6b7280' }}>
                            Filter records using a date range
                          </p>
                        </div>
                      </div>

                      <button
                        type="button"
                        onClick={handleDateFilterRefresh}
                        title="Refresh"
                        style={{
                          width: '48px',
                          height: '48px',
                          borderRadius: '50%',
                          backgroundColor: '#223843',
                          border: 'none',
                          color: '#ffffff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease',
                          flexShrink: 0,
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1.05)'
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1)'
                        }}
                      >
                        <FaSyncAlt size={18} />
                      </button>
                    </div>
                  </div>

                  <Card.Body className="p-4" style={{ backgroundColor: '#ffffff' }}>
                    <Row className="g-3">
                      <Col xs={12} md={6} className="text-start">
                        <Form.Group className="mb-0">
                          <Form.Label
                            className="fw-semibold mb-2"
                            style={{
                              color: '#6b7280',
                              fontSize: '13px',
                              fontFamily: 'Inter, system-ui, sans-serif',
                            }}
                          >
                            Start Date
                          </Form.Label>
                          <Form.Control
                            type="date"
                            value={
                              fromDate instanceof Date && !isNaN(fromDate)
                                ? fromDate.toISOString().split('T')[0]
                                : ''
                            }
                            onChange={(e) =>
                              setFromDate(
                                e.target.value ? new Date(e.target.value) : null,
                              )
                            }
                            style={{
                              borderRadius: '8px',
                              border: '1px solid #D1D3D4',
                              fontSize: '14px',
                              height: '40px',
                              backgroundColor: '#ffffff',
                              fontFamily: 'Inter, system-ui, sans-serif',
                            }}
                            onFocus={(e) => {
                              e.target.style.borderColor = '#223843'
                            }}
                            onBlur={(e) => {
                              e.target.style.borderColor = '#D1D3D4'
                            }}
                          />
                        </Form.Group>
                      </Col>

                      <Col xs={12} md={6} className="text-start">
                        <Form.Group className="mb-0">
                          <Form.Label
                            className="fw-semibold mb-2"
                            style={{
                              color: '#6b7280',
                              fontSize: '13px',
                              fontFamily: 'Inter, system-ui, sans-serif',
                            }}
                          >
                            End Date
                          </Form.Label>
                          <Form.Control
                            type="date"
                            value={
                              toDate instanceof Date && !isNaN(toDate)
                                ? toDate.toISOString().split('T')[0]
                                : ''
                            }
                            onChange={(e) =>
                              setToDate(
                                e.target.value ? new Date(e.target.value) : null,
                              )
                            }
                            style={{
                              borderRadius: '8px',
                              border: '1px solid #D1D3D4',
                              fontSize: '14px',
                              height: '40px',
                              backgroundColor: '#ffffff',
                              fontFamily: 'Inter, system-ui, sans-serif',
                            }}
                            onFocus={(e) => {
                              e.target.style.borderColor = '#223843'
                            }}
                            onBlur={(e) => {
                              e.target.style.borderColor = '#D1D3D4'
                            }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              )}
            </div>

            <div
              style={{
                border: '1px solid #D1D3D4',
                borderRadius: '12px',
                overflow: 'hidden',
                backgroundColor: '#ffffff',
              }}
            >
              <div
                className="d-flex flex-wrap justify-content-between align-items-center gap-3"
                style={{
                  padding: isMobile ? '14px 16px' : '16px 20px',
                  borderBottom: '1px solid #F3F4F6',
                  backgroundColor: '#ffffff',
                }}
              >
                <div className="d-flex align-items-center gap-3">
                  <div
                    style={{
                      width: '40px',
                      height: '40px',
                      borderRadius: '50%',
                      backgroundColor: '#223843',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                    }}
                  >
                    <BsCalendar3 style={{ color: '#ffffff', fontSize: '18px' }} />
                  </div>
                  <div className="text-start">
                    <div
                      style={{
                        fontSize: '16px',
                        fontWeight: 700,
                        color: '#111827',
                        fontFamily: 'Inter, system-ui, sans-serif',
                        lineHeight: 1.2,
                      }}
                    >
                      {calendarMonth.toLocaleDateString('en-GB', {
                        month: 'long',
                        year: 'numeric',
                      })}
                    </div>
                    <div
                      style={{
                        fontSize: '12px',
                        color: '#6b7280',
                        fontFamily: 'Inter, system-ui, sans-serif',
                        marginTop: '2px',
                      }}
                    >
                      {monthStats.total > 0
                        ? `${monthStats.total} record${monthStats.total === 1 ? '' : 's'} this month`
                        : 'No records this month'}
                    </div>
                  </div>
                </div>

                <div className="d-flex align-items-center gap-2">
                  <button
                    type="button"
                    onClick={goToPrevMonth}
                    title="Previous month"
                    style={{
                      width: '40px',
                      height: '40px',
                      borderRadius: '50%',
                      backgroundColor: '#ffffff',
                      border: '1px solid #D1D3D4',
                      color: '#223843',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                    }}
                  >
                    <BsChevronLeft size={16} />
                  </button>
                  <button
                    type="button"
                    onClick={goToCurrentMonth}
                    style={{
                      height: '40px',
                      padding: '0 14px',
                      borderRadius: '20px',
                      backgroundColor: '#223843',
                      border: 'none',
                      color: '#ffffff',
                      fontSize: '13px',
                      fontWeight: 600,
                      fontFamily: 'Inter, system-ui, sans-serif',
                      cursor: 'pointer',
                    }}
                  >
                    Today
                  </button>
                  <button
                    type="button"
                    onClick={goToNextMonth}
                    title="Next month"
                    style={{
                      width: '40px',
                      height: '40px',
                      borderRadius: '50%',
                      backgroundColor: '#ffffff',
                      border: '1px solid #D1D3D4',
                      color: '#223843',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                    }}
                  >
                    <BsChevronRight size={16} />
                  </button>
                </div>
              </div>

              <div
                className="d-flex flex-wrap gap-2"
                style={{
                  padding: isMobile ? '12px 16px' : '14px 20px',
                  borderBottom: '1px solid #F3F4F6',
                }}
              >
                {[
                  { label: 'Present', color: '#10B981', count: monthStats.present },
                  { label: 'Absent', color: '#EF4444', count: monthStats.absent },
                  { label: 'Leave', color: '#F59E0B', count: monthStats.leave },
                  { label: 'Half day', color: '#3B82F6', count: monthStats.half_day },
                  { label: 'Late', color: '#8B5CF6', count: monthStats.late },
                ]
                  .filter(
                    (item) =>
                      item.count > 0 ||
                      ['Present', 'Absent', 'Leave'].includes(item.label),
                  )
                  .map((item) => (
                    <div
                      key={item.label}
                      className="d-flex align-items-center gap-2"
                      style={{
                        padding: '6px 12px',
                        borderRadius: '999px',
                        backgroundColor: '#F3F4F6',
                        fontFamily: 'Inter, system-ui, sans-serif',
                        fontSize: '12px',
                        color: '#374151',
                        fontWeight: 600,
                      }}
                    >
                      <span
                        style={{
                          width: '10px',
                          height: '10px',
                          borderRadius: '50%',
                          backgroundColor: item.color,
                          flexShrink: 0,
                        }}
                      />
                      {item.label}: {item.count}
                    </div>
                  ))}
              </div>

              <div style={{ padding: isMobile ? '12px' : '16px 20px 20px' }}>
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
                    gap: isMobile ? '4px' : '8px',
                    marginBottom: isMobile ? '8px' : '10px',
                  }}
                >
                  {WEEKDAYS.map((day) => (
                    <div
                      key={day}
                      style={{
                        textAlign: 'center',
                        fontSize: isMobile ? '11px' : '12px',
                        fontWeight: 700,
                        color: '#6b7280',
                        fontFamily: 'Inter, system-ui, sans-serif',
                        padding: '6px 0',
                      }}
                    >
                      {day}
                    </div>
                  ))}
                </div>

                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
                    gap: isMobile ? '4px' : '8px',
                  }}
                >
                  {calendarDays.map((cell) => {
                    if (cell.type === 'empty') {
                      return (
                        <div
                          key={cell.key}
                          style={{
                            minHeight: isMobile ? '48px' : '72px',
                            borderRadius: '10px',
                            backgroundColor: 'transparent',
                          }}
                        />
                      )
                    }

                    const status = cell.attendance
                      ? normalizeStatus(cell.attendance.status)
                      : null
                    const isSelected = selectedDayKey === cell.key
                    const isToday = todayKey === cell.key
                    const statusColor = status
                      ? getStatusColor(cell.attendance.status)
                      : '#111827'
                    const statusBg = status
                      ? getStatusBg(cell.attendance.status)
                      : '#F9FAFB'

                    return (
                      <button
                        key={cell.key}
                        type="button"
                        onClick={() =>
                          setSelectedDayKey((prev) =>
                            prev === cell.key ? null : cell.key,
                          )
                        }
                        style={{
                          minHeight: isMobile ? '48px' : '72px',
                          borderRadius: '10px',
                          border: isSelected
                            ? `2px solid ${statusColor}`
                            : isToday
                            ? '2px solid #223843'
                            : '1px solid #E5E7EB',
                          backgroundColor: statusBg,
                          padding: isMobile ? '6px 4px' : '8px',
                          cursor: 'pointer',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-start',
                          justifyContent: 'space-between',
                          textAlign: 'left',
                          transition: 'transform 0.15s ease, box-shadow 0.15s ease',
                          boxShadow: isSelected
                            ? '0 4px 12px rgba(34, 56, 67, 0.12)'
                            : 'none',
                        }}
                      >
                        <span
                          style={{
                            fontSize: isMobile ? '12px' : '14px',
                            fontWeight: isToday || status ? 700 : 600,
                            color: status ? statusColor : '#111827',
                            fontFamily: 'Inter, system-ui, sans-serif',
                            lineHeight: 1,
                          }}
                        >
                          {cell.day}
                        </span>
                        {status ? (
                          <span
                            style={{
                              fontSize: isMobile ? '9px' : '11px',
                              fontWeight: 700,
                              color: statusColor,
                              fontFamily: 'Inter, system-ui, sans-serif',
                              letterSpacing: '0.02em',
                              marginTop: '4px',
                              width: '100%',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {isMobile
                              ? formatDisplayStatus(cell.attendance.status).charAt(0)
                              : formatDisplayStatus(cell.attendance.status)}
                          </span>
                        ) : (
                          <span
                            style={{
                              fontSize: isMobile ? '9px' : '11px',
                              color: '#9CA3AF',
                              fontFamily: 'Inter, system-ui, sans-serif',
                              marginTop: '4px',
                            }}
                          >
                            —
                          </span>
                        )}
                      </button>
                    )
                  })}
                </div>

                {(!selectedData || selectedData.length === 0) && (
                  <div
                    style={{
                      marginTop: '16px',
                      padding: '16px',
                      textAlign: 'center',
                      color: '#6b7280',
                      fontSize: '14px',
                      fontFamily: 'Inter, system-ui, sans-serif',
                      backgroundColor: '#F9FAFB',
                      borderRadius: '10px',
                    }}
                  >
                    No attendance data found.
                  </div>
                )}
              </div>
            </div>

            {selectedDayKey && (
              <div
                style={{
                  marginTop: '16px',
                  border: '1px solid #D1D3D4',
                  borderRadius: '12px',
                  backgroundColor: '#ffffff',
                  padding: isMobile ? '14px 16px' : '18px 20px',
                }}
              >
                <div
                  style={{
                    fontSize: '15px',
                    fontWeight: 700,
                    color: '#111827',
                    fontFamily: 'Inter, system-ui, sans-serif',
                    marginBottom: '12px',
                  }}
                >
                  {new Date(`${selectedDayKey}T00:00:00`).toLocaleDateString(
                    'en-GB',
                    {
                      weekday: 'long',
                      day: '2-digit',
                      month: 'long',
                      year: 'numeric',
                    },
                  )}
                </div>

                {selectedDayAttendance ? (
                  <Row className="g-3">
                    <Col xs={12} md={4} className="text-start">
                      <div
                        style={{
                          fontSize: '12px',
                          color: '#6b7280',
                          fontFamily: 'Inter, system-ui, sans-serif',
                          marginBottom: '4px',
                        }}
                      >
                        Status
                      </div>
                      <div
                        style={{
                          fontSize: '16px',
                          fontWeight: 700,
                          color: getStatusColor(selectedDayAttendance.status),
                          fontFamily: 'Inter, system-ui, sans-serif',
                        }}
                      >
                        {formatDisplayStatus(selectedDayAttendance.status)}
                      </div>
                    </Col>
                    <Col xs={12} md={4} className="text-start">
                      <div
                        style={{
                          fontSize: '12px',
                          color: '#6b7280',
                          fontFamily: 'Inter, system-ui, sans-serif',
                          marginBottom: '4px',
                        }}
                      >
                        Student
                      </div>
                      <div
                        style={{
                          fontSize: '14px',
                          fontWeight: 600,
                          color: '#111827',
                          fontFamily: 'Inter, system-ui, sans-serif',
                        }}
                      >
                        {selectedDayAttendance.student_name ||
                          selectedStudent?.name ||
                          'N/A'}
                      </div>
                    </Col>
                    <Col xs={12} md={4} className="text-start">
                      <div
                        style={{
                          fontSize: '12px',
                          color: '#6b7280',
                          fontFamily: 'Inter, system-ui, sans-serif',
                          marginBottom: '4px',
                        }}
                      >
                        Remarks
                      </div>
                      <div
                        style={{
                          fontSize: '14px',
                          color: '#111827',
                          fontFamily: 'Inter, system-ui, sans-serif',
                        }}
                      >
                        {selectedDayAttendance.remarks || '—'}
                      </div>
                    </Col>
                  </Row>
                ) : (
                  <div
                    style={{
                      fontSize: '14px',
                      color: '#6b7280',
                      fontFamily: 'Inter, system-ui, sans-serif',
                    }}
                  >
                    No attendance marked for this day.
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  )
}
